<script setup>
import AvatarImage from '@/components/shared/AvatarImage.vue'

const props = defineProps({
  size: {
    type: String,
    default: '2.5rem',
  },
  image: {
    type: String,
    default: null,
  },
  initials: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['click'])
</script>
<template>
  <div
    class="avatar-edit"
    role="button"
    :aria-label="props.label"
    @click.stop="emit('click')"
  >
    <avatar-image :size="props.size" :image="props.image" :initials="props.initials" />
    <q-avatar
      class="avatar-edit__badge"
      color="primary"
      text-color="white"
      icon="mdi-pencil"
      :size="`calc(${props.size} * .45)`"
    />
    <q-tooltip>{{ props.label }}</q-tooltip>
  </div>
</template>
<style lang="scss" scoped>
.avatar-edit {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
}
.avatar-edit__badge {
  position: absolute;
  right: -.125rem;
  bottom: -.125rem;
  border: 1px solid white;
  opacity: 0;
  transition: opacity .2s;
}
.avatar-edit:hover .avatar-edit__badge {
  opacity: 1;
}
@media (hover: none) {
  .avatar-edit__badge {
    opacity: 1;
  }
}
</style>
